import { createAction } from '@ngrx/store';

export const checkForUpdate = createAction('[App Updates / User] Check for Update');

export const downloadUpdate = createAction('[App Updates / User] Apply Update');

export const reloadApp = createAction('[App Updates / User] Reload App');
